const j = (r: Response) => r.ok ? r.json() : r.json().then(e => Promise.reject(e));

export async function listThumbnails(taleId: string) {
  const r = await fetch(`/api/thumbnails/tale/${taleId}`, { credentials: 'include' });
  return r.json();
}

export async function generateThumbnails(taleId: string, data?: { count?: number; variants?: string[]; overwrite?: boolean }) {
  const r = await fetch(`/api/thumbnails/${taleId}/generate`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data || {})
  });
  return r.json();
}

export async function rasterizeThumbnail(id: string, width = 1280) {
  const res = await fetch(`/api/thumbnails/${id}/rasterize`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ width })
  });
  return j(res);
}

export async function rasterizeAllThumbnails(taleId: string, opts?: { width?: number; force?: boolean }) {
  const r = await fetch(`/api/thumbnails/${taleId}/rasterize-all`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ width: 1280, force: false, ...(opts||{}) })
  });
  return r.json();
}

export async function regenerateThumbnail(id: string, patch?: {
  title?: string; subtitle?: string; variant?: 'A'|'B'|'C'|'D';
  palette?: { bg: string; fg: string; accent: string };
  rasterize?: boolean;
}) {
  const r = await fetch(`/api/thumbnails/${id}/regenerate`, {
    method: 'POST', credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch || {})
  });
  return r.json();
}

export async function setDefaultThumbnail(id: string) {
  const r = await fetch(`/api/thumbnails/${id}/set-default`, {
    method: 'POST', credentials: 'include'
  });
  return r.json();
}
